import { useMutation } from '@tanstack/react-query'
import { postDepositDetails } from 'services/WalletsService'

export const useDepositDetailsMutation = () => {
  return useMutation({ mutationFn: postDepositDetails })
}
